import React from 'react';
import { useSelector } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneRotary } from '@fortawesome/pro-solid-svg-icons';

// actions
import { acceptIncoming } from '../../../../actions/telephony';

import './styles.scss';

function AcceptCallButton() {
  const { status, ccpAgentState } = useSelector(store => store.telephony);

  return (status === 'connecting' && ccpAgentState === 'PendingBusy') ? (
    <div
      role="button"
      tabIndex={0}
      className="d-flex ps-1 justify-content-center align-items-center accept-call-container"
      onClick={acceptIncoming}
    >
      Accept Call
      <FontAwesomeIcon
        icon={faPhoneRotary}
        size="2x"
        className="ms-2 animate-shake"
      />
    </div>
  ) : null;
}

export default AcceptCallButton;
